<template>
    <div>
        <div style="display: flex;justify-content: space-between;">
          <el-button @click="addContractTpl">添加合同模版</el-button>  
          <span style="font-size: 14px; color: #5e6d82; line-height: 1.5em;">合同模版可以在签署合同的时候进行调用</span>
        </div>

        <el-table :data="pageProps.records" style="width: 100%"  >
            <el-table-column   prop="contract_name" label="合同标题"></el-table-column>
        
            <el-table-column   prop="contract_type" label="合同类型">
            <template slot-scope="scope">
              <a style="color: #03ba48">{{ scope.row.contract_type|contractTypesFilter }}</a>
            </template>
          </el-table-column>
            <el-table-column  label="操作">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="deleteRow(scope.row)"  type="text"  size="small">
                  移除
                </el-button>
                <!--scope.$index-->

                <el-button
                  @click.native.prevent="editRow(scope.row)"  type="text"  size="small">
                  编辑
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div style="text-align:center;padding:20px">
            <!--分页-->
            <el-pagination
              background
              :hide-on-single-page="true"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageProps.total"
              :page-size="pageProps.pageSize"
              :page-sizes="[5, 10, 50, 100]"
              :current-page="pageProps.pageNum"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>

          <contract-tpl-dialog ref="contractRefDialog" :project_id="searchFormData.project_id" @refresh="fetchData"></contract-tpl-dialog>
    </div>
  </template>
  <script>
  import { contractTplList,addContractTpl,delContractTpl} from "@/api/director/project/index.js";
  import ImageUpload from '@/components/ImageUpload';
  import urlConfig from '@/api/config'
  import ContractTplDialog from '@/views/director/work/project/setting/part/dialog/contract-tpl-dialog.vue';
  
  export default {
    components: {
      ImageUpload,
      ContractTplDialog
    },
  
 
  
    data () {
      return {
        uploadFileUrl:  urlConfig.prod.baseURL +"/web/file/Upload", // 上传的图片服务器地址

        searchLoading: false,
        pageProps: {
          records:[],
          total: 0,
          pageSize: 10,
          pageNum: 1
        },

        searchFormData:{
          project_id:"",
          keyword:"",
          page:0,
          limit:0
        },


        rules: {
          project_id: [
            { required: true, message: '请选择项目', trigger: 'change' }
          ],
         
          template_name: [
            { required: true, message: '请输入标题', trigger: 'blur' }
          ],
        
        }
  
      }
    },

    filters: {
    contractTypesFilter(status) {
      const statusMap = {
        1: '在线合同',
        2: '本地合同',
      }
      return statusMap[status]
    },
  
  },


  
    created(){
     
    },
    mounted () {
      console.log("this.$route.query",this.$route.query);
  
      if(this.$route.query&&this.$route.query.project_id){
        this.project_id=this.$route.query.project_id;
        this.searchFormData.project_id=this.$route.query.project_id;
        this.fetchData();
      }
     
    },
    methods:{

      addContractTpl(){
        this.$refs.contractRefDialog.init();
      },
      
      //项目列表
      search(){
        this.fetchData();
      },


      fetchData(){
        var that = this;
        that.searchFormData.page=that.pageProps.pageNum;
        that.searchFormData.limit=that.pageProps.pageSize;

        contractTplList(that.searchFormData).then((response) => {
          console.log(response);
          if(response.code==200){
            that.pageProps.records = response.data.data;
            that.pageProps.total = response.data.total;
          }else{
            that.$message.error(response.msg?response.msg:"请求错误");
          }
         
        });
      },

       // 当前页变更
      handleCurrentChange(num) {
        this.pageProps.pageNum = num
        this.fetchData()
      },


      // 每页显示页面数变更
      handleSizeChange(size) {
        this.pageProps.pageSize = size
        this.fetchData()
      },


      deleteRow(item) {
          //this.pageProps.records.splice(index, 1);
        var that=this;
        this.$confirm('确定删除模版?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
            const template_id	=item.template_id;
            delContractTpl({template_id:template_id}).then((response) => {
              console.log(response);
              if(response.code==200){
                  that.fetchData();
              }else{
                that.$message.error(response.msg?response.msg:"操作失败");

              }
            });
          
        }).catch(() => {
        
        });

      },

      editRow(item){
        this.$refs.contractRefDialog.init(item);
      }

    
    }
  }
  </script>
  
  <style lang="scss" scoped>

  </style>